export default "__VITE_ASSET__763ed375__"